//荷兰语
export default {
    login1: 'Heb je al een account? ',
    login2: 'Ga naar inloggen',
    login3: 'Wachtwoord resetten? ',
    login4: 'Begin met het gebruiken van 51shopy',
    login5: 'Wachtwoord vergeten?',
    login6: 'Registreer nu',
    login7: 'E-mail',
    login8: 'Verificatiecode',
    login9: 'Voer verificatiecode in',
    login10: 'wachtwoord',
    login11: 'Bevestig wachtwoord',
    login12: 'Voer uw wachtwoord opnieuw in',
    login13: 'Registreren',
    login14: 'Volgende stap',
    login15: 'Verzenden',
    login16: 'Verificatiecode verzenden',
    login17: 'Voer het juiste e-mailadres en de verificatiecode in! ',
    login18: 'De wachtwoorden die u twee keer hebt ingevoerd, komen niet overeen!',
    login19: 'Verificatiecode is verzonden',
    login20: 'E-mailadres mag niet leeg zijn',
    login21: 'Het e-mailformaat is onjuist',
    login22: 'De verificatiecode mag niet leeg zijn',
    login23: 'De lengte van de verificatiecode is 4 tekens',
    login24: 'Het wachtwoord mag niet leeg zijn',
    login25: 'De lengte van het wachtwoord mag niet korter zijn dan 6 tekens',
    login26: 'Wachtwoord succesvol gewijzigd! ',
    login27: 'Registratie succesvol! ',
    login28: 'Inloggen succesvol',
    login29: 'De accountnaam mag niet leeg zijn',
    login30: 'Log hieronder in op uw account om te beginnen',
    login31: 'Account',
    login32: 'Klik om in te loggen',
    login33: "Koop kwaliteitsproducten en geniet van bonussen",
    login34: "Registreer en geniet van een prachtig cadeau",
    login35: "Inloggen",
    login36: "Registreren",

    home1: 'Populair',
    home2: 'Weet u zeker dat u wilt uitloggen? ',
    home3: 'Aanwijzing',
    home4: 'Oké',
    home5: 'Annuleren',
    home6: 'Fans',
    home7: 'Volgen',
    home8: 'Persoonlijk Centrum',
    home9: 'Ik heb het gekocht',
    home10: 'Ik heb het verkocht',
    home11: 'Mijn portemonnee',
    home12: 'Afsluiten',
    home13: 'Totaal',
    home14: 'artikelen',
    home15: 'Schikking',
    home16: 'Betaalbare prijs',
    home17: 'Snelle logistiek',
    home18: 'Kwaliteitsborging',
    home19: 'Over ons',
    home20: 'Helpcentrum',
    home21: 'Aftersales service',
    home22: 'Levering en aanvaarding',
    home23: 'Zakelijke samenwerking',
    home24: 'Zoek aanbevelingen',
    home25: 'Vriendelijke links',
    home26: 'Volgen',
    home27: 'Al bezorgd',
    home28: 'Koop nu',
    home29: 'In winkelwagen',
    home30: 'Succesvol verzameld! ',
    home31: 'De incasso is succesvol geannuleerd! ',
    home32: 'Weet je zeker dat je wilt ontvolgen?',
    home33: 'Succesvol geannuleerd! ',
    home34: 'Volg succes! ',
    home35: 'Inhoud kan niet leeg zijn',
    home36: 'Commentaar succesvol!',
    home37: 'Productbeoordelingen',
    home38: 'Evalueer nu',
    home39: 'Evaluatie',
    home40: 'Geschiedenis',
    home41: 'Succesvol ontvolgen! ',
    home42: 'Deze man is erg mysterieus en heeft geen bio. ',
    home43: 'Startpagina',
    number1: 'Mijn account',
    number2: 'Persoonlijk Centrum',
    number3: 'Portemonnee',
    number4: 'Mijn favorieten',
    number5: 'Mijn aandacht',
    number6: 'Mijn fans',
    number7: 'Geschiedenis browsen',
    number8: 'Transactiebeheer',
    number9: 'ik heb gepost',
    number10: 'ik heb gekocht',
    number11: 'Ik heb het verkocht',
    number12: 'Winkelwagen',
    number13: 'Persoonlijke homepage',
    number14: 'Klantenservice',
    number15: 'Instellingen',
    number16: 'Toevoegen',
    number17: 'Adres wijzigen',
    number18: 'Alleen afbeeldingsbestanden kunnen worden geüpload!',
    number19: 'De bestandsgrootte mag niet groter zijn dan 10 MB!',
    number20: 'Afbeelding succesvol geüpload',
    number21: 'Balans',
    number22: 'Items verzamelen',
    number23: 'Persoonlijke gegevens',
    number24: 'Bewerken',
    number25: 'Verzenden',
    number26: 'Bijnaam',
    number27: 'Persoonlijk profiel',
    number28: 'afleveradres',
    number29: 'Toevoegen',
    number30: 'Standaard',
    number31: 'Niet betaald',
    number32: 'Wachten op levering',
    number33: 'Voltooid',
    number34: 'Geannuleerd',
    number35: 'In afwachting van beoordeling',
    number36: 'Geslaagd',
    number37: 'Afgewezen',
    number38: 'Bestelling voltooid',
    number39: 'Bestelling betaald!',
    number40: 'Bestelling succesvol geannuleerd! ',
    number41: 'Opname succesvol! ',
    number42: 'Opladen',
    number43: 'Trek terug',
    number44: 'Consumptiegeschiedenis',
    number45: 'Ordernummer',
    number46: 'betalingsnaam',
    number47: 'Alles',
    number48: 'Vraag',
    number49: 'Bestelnummer',
    number50: 'betalingsnaam',
    number51: '51 munt',
    number52: 'Bestelstatus',
    number53: 'Tijd voor het aanmaken van de bestelling',
    number54: 'Tijd voor update van bestelling',
    number55: 'Operatie',
    number56: 'Betaald',
    number57: 'Bestelling annuleren',
    number58: 'Details',
    number59: 'Nummer',
    number60: 'verzonden',
    number61: 'in afwachting',
    number62: 'Opnamerecord',
    number63: 'gebruikers-id',
    number64: 'Opnamebedrag',
    number65: 'Status',
    number66: 'Scheppingstijd',
    number67: 'Opnemen uit portemonnee',
    number68: 'Trek je terug',
    number69: 'Portemonnee-bestellingsgegevens',
    number70: 'Alle bestellingen',
    number71: 'In afwachting van betaling',
    number72: 'Wachten op levering',
    number73: 'Voltooid',
    number74: 'Geannuleerd',
    number75: 'Betaald',
    number76: 'Alle zendingen',
    number77: 'Logistiek ordernummer',
    number78: 'Verzending succesvol!',
    number79: 'ik heb het verkocht',
    number80: 'Nog geen ordergegevens',
    number81: 'Ordernummer',
    number82: 'Besteltijd',
    number83: 'Bestel persoon',
    number84: 'Tijd wijzigen',
    number85: 'Details',
    number86: 'Totaal',
    number87: 'verzonden',
    number88: 'Details',
    number89: 'Vul het logistieke ordernummer in',
    number90: 'Logistiek ordernummer',
    number91: 'Voer het logistieke ordernummer in',
    number92: 'Annuleren succesvol!',
    number93: 'Succes!',
    number94: 'Bestelling vertraagd bezorgd succesvol!',
    number95: 'ik heb gekocht',
    number96: 'Betaal nu',
    number97: 'Bevestig ontvangst',
    number98: 'Vertraagde levering',
    number99: 'Bestelling annuleren',
    number100: 'Verkoper Gebruiker',
    number101: 'Mijn verzameling',
    number102: 'Mijn fans',
    number103: 'Mijn Volgen',
    number104: 'betalingsnaam',
    number105: '51 munt',
    number106: 'Bestelstatus',
    number107: 'Betalingstijd',
    number108: 'Ik heb betaald',
    number109: 'Betaling succesvol! ',
    number110: 'Alle producten',
    number111: 'Weet u zeker dat u het product wilt verwijderen?',
    number112: 'Succesvol verwijderd! ',
    number113: 'Succesvol geannuleerd! ',
    number114: 'Weet u zeker dat u het product in het schap wilt leggen?',
    number115: 'Weet u zeker dat u het product wilt verwijderen?',
    number116: 'Succes! ',
    number117: 'Op de plank',
    number118: 'kant-en-klaar',
    number119: 'Verwijderen',
    number120: 'Details bekijken',
    cart1: 'Productinformatie',
    cart2: 'eenheidsprijs',
    cart3: 'Hoeveelheid',
    cart4: 'Subtotaal',
    cart5: 'operatie',
    cart6: 'eenheidsprijs',
    cart7: 'Weet u zeker dat u wilt verwijderen?',
    cart8: 'Bevestigen',
    cart9: 'Annuleren',
    cart10: 'verwijderen',
    cart11: 'De winkelwagenlijst is leeg',
    cart12: 'items, totaal aantal items',
    cart13: 'Totaal',
    cart14: 'Schikking',
    cart15: 'Adres toevoegen',

    cart16: 'Een van telegram en watchApp moet worden ingevuld',
    cart17: 'Configuratie gebruikersinformatie succesvol!',
    cart18: 'Selecteer of vul het afleveradres in! ',
    cart19: 'Bestelling succesvol aangemaakt! ',
    cart20: 'afleveradres',
    cart21: 'U moet een afleveradres toevoegen voordat u de bestelling verzendt. ',
    cart22: 'Geadresseerde',
    cart23: 'Contactgegevens',
    cart24: 'afleveradres',
    cart25: 'Adres wisselen',
    cart26: 'Adres toevoegen',
    cart27: 'Productinformatie',
    cart28: 'Eenheidsprijs',
    cart29: 'Hoeveelheid',
    cart30: 'Werkelijke betaling',
    cart31: 'Totale prijs',
    cart32: 'Bedragdetails',
    cart33: 'Totaal te betalen bedrag',
    cart34: 'Bestellen',
    cart35: 'Afleveradres wijzigen',
    cart36: 'Annuleren',
    cart37: 'Oké',
    cart38: 'Gebruikersinformatie',
    cart39: 'Verzenden',
    cart40: 'Achternaam mag niet leeg zijn',
    cart41: 'Naam mag niet leeg zijn',
    cart42: 'Mobiel nummer mag niet leeg zijn',
    cart43: 'Land kan niet leeg zijn',
    cart44: 'Provincie/Gemeente/District kan niet leeg zijn',
    cart45: 'Stad kan niet leeg zijn',
    cart46: 'Gedetailleerd adres mag niet leeg zijn',
    cart47: 'Postcode mag niet leeg zijn',
    cart48: 'Adres succesvol gewijzigd! ',
    cart49: 'Adres succesvol toegevoegd! ',
    cart50: 'achternaam',
    cart51: 'naam',
    cart52: 'Land',
    cart53: 'Provincie/Gemeente/Regio',
    cart54: 'stad',
    cart55: 'Gedetailleerd adres',
    cart56: 'Postcode',
    cart57: 'Contact telefoonnummer',
    cart58: 'Is het standaard',
    cart59: 'Startpagina',
    cart60: 'Klantenservice',
    cart61: 'Publiceren',
    cart62: 'Mijn',
    cart63: 'winkelwagen',
    cart64: 'Verzendtijd',
    cart65: 'Betaaltijd',
    cart66: 'Bezorginformatie',
    cart67: 'Werkelijke betaling',
    cart68: 'Verzenden naar',
    cart69: 'Producten',
    cart70: 'U kunt een factuur aanvragen',
    cart71: 'Bestelgegevens',
    cart72: 'Handelaar',
    cart73: 'Inzending succesvol! ',
    cart74: 'Kopiëren succesvol',
    cart75: 'Kopiëren mislukt',
    cart76: 'verhouding',
    cart77: 'Kredietlimiet',
    cart78: 'Overdragen',
    cart79: 'Bedrag opladen',
    cart80: 'Opladen',
    cart81: 'Classificatie',
    setup1: 'Persoonlijke gegevens',
    setup2: 'Mijn afleveradres',
    setup3: 'Mijn profiel',
    setup4: 'Account en beveiliging',
    setup5: 'Privacy',
    setup6: 'Algemeen',
    setup7: 'Help en Feedback',
    setup8: 'Over ons',
    setup9: 'Uitloggen',
    setup10: 'Stationbericht',
    setup11: 'Nog geen gegevens',
    setup12: 'Succesvol toegevoegd aan winkelwagen!',
    setup13: 'Toevoegen aan winkelwagen mislukt!',

    setup14: 'Productbewerking',
    setup15: 'Productrelease',
    setup16: 'Productcover afbeelding',
    setup17: 'Productcategorie',
    setup18: 'Productnaam',
    setup19: 'Productprijs (CNY)',
    setup20: 'Productbeschrijving',
    setup21: "Productfoto's (Max. 10 afbeeldingen)",
    setup22: 'Resetten',
    setup23: 'Product succesvol aangemaakt! ',
    setup24: 'Onvoldoende productvoorraad! ',
    setup25: 'Betaalmethode',
    setup26: '51munt',
    setup27: 'overdracht',
    setup28: 'Productlink of naam/artikellink',
    setup29: 'De gebruiker is geen verkoper en kan geen producten publiceren! ',
    setup30: 'Niet-menselijke bewerking gedetecteerd! ',
    setup31: 'Productinventaris',
    setup32: 'Weergaven',
    setup33: 'Bestelling succesvol verzonden! ',
    setup34: 'Bestelling bekijken',
    setup35: 'Productinventaris',
    setup36: 'Productcategorie kan niet leeg zijn',
    setup37: 'Productnaam mag niet leeg zijn',
    setup38: 'Productbeschrijving mag niet leeg zijn',
    setup39: 'Productvoorraad mag niet leeg zijn',
    setup40: 'Productprijs kan niet leeg zijn',
    setup41: 'Omslagafbeelding mag niet leeg zijn',
    setup42: 'Productafbeelding kan niet leeg zijn',
    setup43: 'Overdracht is uitgevoerd en wacht op bevestiging',
    setup44: 'Selecteer de overdrachtsmethode! ',
    setup45: 'Voltooiingstijd',
    setup46: '51 Munt',
    setup47: 'Overschrijving',
    setup48: 'Overdrachtsmethode',
    setup49: "Productdetails",
    setup50: "Koper",
    setup51: "Productverzendkosten zijn",
    setup52: "Verzendkosten",
    setup53: "Verkoophoeveelheid",
    setup54: "Minimale aankoophoeveelheid",
    setup55: "Toevoegen",
    setup56: "Account is ontvangen",
    setup57: "Contactgegevens van de begunstigde",
    setup58: "Contactgegevens verkoper",
    setup59: "Contactgegevens koper",
    setup60: "Kopiëren",
    setup61: "Populair",
    setup62: "Vul minimaal één veld in",
    setup63: "Neem contact met ons op",
    setup64: "Verzendkostenraming",
    setup65: "Abonneer u op ons",
    setup66: "Overzeese samenwerking met beroemdheden op internet",
    setup67: "Betalings- en aftersalesproblemen",
    setup68: "Gebruikersdividenden",

    setup69: "Valutatype",
    setup70: "Wisselkoers",
    setup71: "Verwerkingskosten",
    setup72: "Werkelijke ontvangst",
    setup73: "Minimaal opnamebedrag",
    setup74: "Valuta",
    setup75: "Verwerkingskosten",
    setup76: "Werkelijke ontvangst",

    setup78: "Uitnodigingscode",
    setup79: "Voer de uitnodigingscode in",
    setup80: "Mobiele netnummer kan niet leeg zijn",
    setup81: "Netnummer",
    setup82: "Tijd annuleren",
    setup83: "Opnamegegevens",
    setup84: "Dividendendetails",
    setup85: "Is het verlopen?",
    setup86: "Of te gebruiken",
    setup87: "Niet verlopen",
    setup88: "Verlopen",
    setup89: "Niet gebruikt",
    setup90: "Al gebruikt",
    setup91: "Gedeeltelijk gebruikt",
    setup92: "korting",
    setup93: "Gebruikte korting",
    setup94: "Resterende korting",
    setup95: "Of te gebruiken",
    setup96: "Is het verlopen?",
    setup97: "Vervaldatum",
    setup98: "Kortingstijd",
    setup99: "Alliantie delen",
    setup100: "Betaling annuleren",
    setup101: "Sluit de interface",
    setup102: "USDT-betaling",
    setup103: "Bedrag",
    setup104: "Transactiebedrag van bestelling",
    setup105: "Netwerk",
    setup106: "U betaalt voor het netwerk",
    setup107: "Betaling succesvol",
    setup108: "Portemonnee-adres begunstigde",
    setup109: "Controleer zorgvuldig of het daadwerkelijke betalingsbedrag overeenkomt met het bedrag dat u hebt overgemaakt. Als er een fout is gemaakt, draagt ​​u zelf de gevolgen",
    setup110: "Vervaldatum",
    setup111: "Wachten op betaling",
    setup112: "Betaling succesvol",
    setup113: "Bestelling verlopen",
    setup114: "Controleer blockchaintransacties",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "Over ons",
    setup131: "Levering gerelateerd",
    setup132: "Anders",
    setup133: "Verzendbeleid",
    setup134: "Pakket bezorg-/ophaaltijd",
    setup135: "Servicevoorwaarden",
    setup136: "Betaalmethode",
    setup137: "Retourbeleid",
    setup138: "Privacybeleid",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Werkuren:",
    setup141: "Contactpersoon:",
    setup142: "Bedrijfs-e-mail:",
    setup143: "Postcode:",
    setup144: "Adres: ",

    setup0140: "Maandag tot en met vrijdag (9:00-18:00)",
    setup0141: " Meneer Liang",
    setup0143: "999077",
    setup0144: "Kamer 341, 3/F, Openbaar Industrieel Gebouw, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",
    setup145: "Internationale pakketverzendovereenkomst",
    setup146: "Vanwege de bijzonderheid van internationaal transport, moet u voldoen aan de internationale regels voor pakketvervoer. Zorg ervoor dat u de volgende algemene voorwaarden zorgvuldig leest en accepteert.",
    setup147: "Pakketcompensatiestandaard:",
    setup148: "Als uw producten verloren gaan, ontbreken, beschadigd raken, vertraagd worden of door de douane worden vastgehouden tijdens het transport om redenen die buiten de controle van 51shopy liggen, is 51shopy niet aansprakelijk voor compensatie. Wij aanvaarden ook geen aansprakelijkheid voor indirecte, ongerealiseerde winstverliezen. Raadpleeg voor actuele details 'Pakketverzekering en compensatie.",
    setup149: "51shopy is niet aansprakelijk voor compensatie in de volgende gevallen (voor onverzekerde pakketten):",
    setup150: "1. Er wordt geen compensatie gegeven voor postverlies veroorzaakt door overmacht zoals natuurrampen of douaneredenen;",
    setup151: "2. Indien de verzonden poststukken in strijd zijn met verboden of beperkingen, zullen de bevoegde autoriteiten deze in beslag nemen of behandelen in overeenstemming met de relevante wetten en voorschriften zonder compensatie;",
    setup152: "3. Bij het verzenden van een pakket, als het pakket in goede staat is verpakt, geen tekenen van demontage vertoont en niet is afgevallen, maar de interne onderdelen ontbreken of zijn beschadigd, wordt er geen compensatie gegeven;",
    setup153: "4. Als uit de posttrack blijkt dat het pakket niet op de normale manier is afgeleverd en het logistieke bedrijf bevestigt dat het pakket door de douane in beslag is genomen, zal het onderzoek van het logistieke bedrijf prevaleren en zal er geen compensatie worden gegeven;",
    setup154: "5. Er wordt geen compensatie gegeven als de mail verloren gaat of de inhoud ontbreekt door toedoen van de klant of de mail zelf;",
    setup155: "6. Als de klant geen aanvraag doet en geen claim indient vanaf de datum van levering van de e-mail tot het verstrijken van de aanvraagperiode, wordt er geen compensatie verstrekt;",
    setup156: "7. Indien internationale post door het land van bestemming wordt vastgehouden, in beslag genomen of vernietigd overeenkomstig de nationale wetgeving, wordt er geen compensatie verstrekt.",
    setup157: "Verboden items",
    setup158: "Voldoe aan de voorschriften van ons land met betrekking tot verboden en beperkte artikelen:",
    setup159: "1. Volg de aankondiging van het Staatspostbureau, het Ministerie van Openbare Veiligheid en het Ministerie van Staatsveiligheid over de uitgifte van de 'Reglementering inzake het beheer van verboden artikelen'.",
    setup160: "2. Voldoen aan de bepalingen van Algemene Douane-administratieverordening nr. 43 (Lijst van verboden en beperkte artikelen voor import en export van de Volksrepubliek China).",
    setup161: "Artikelen die niet per post kunnen worden verzonden",
    setup162: "1. Artikelen waarvan het verkeer en transport verboden zijn volgens de nationale wetgeving.",
    setup163: "2. Explosieve, ontvlambare, corrosieve, radioactieve of giftige gevaarlijke goederen.",
    setup164: "3. Publicaties, boeken, materialen of artikelen die reactionaire of obscene inhoud bevatten.",
    setup165: "4. Verschillende valuta's.",
    setup166: "5. Items die de volksgezondheid schenden.",
    setup167: "6. Bederfelijke artikelen.",
    setup168: "7. Levende dieren (behalve bijen, zijderupsen en bloedzuigers, zolang de verpakking de veiligheid van de werknemers waarborgt).",
    setup169: "8. Onvoldoende verpakking kan een gevaar vormen voor werknemers of andere verpakte artikelen besmetten of beschadigen.",
    setup170: "9. Andere items die niet geschikt zijn voor verzending.",
    setup171: "Artikelen die volgens de postpraktijk niet bezorgd mogen worden",
    setup172: "1. Artikelen waarvan de kwaliteit of verpakking schade kan toebrengen aan postmedewerkers of andere pakketten of postapparatuur kan besmetten/beschadigen.",
    setup173: "2. Items met metalen zegels of andere scherpe randen die de postverwerking kunnen verstoren.",
    setup174: "3. Verschillende soorten vuurwapens, munitie, explosieve, ontvlambare, corrosieve, radioactieve materialen of containers, sterke gifstoffen, verdovende middelen, biochemische producten en infectieuze materialen.",
    setup175: "4. Alle publicaties, propagandamateriaal of gedrukt materiaal dat de sociale zekerheid en stabiliteit in gevaar kan brengen of obscene inhoud kan bevatten.",
    setup176: "5. Verschillende items die de volksgezondheid in gevaar kunnen brengen.",
    setup177: "6. Documenten of artikelen die niet worden geaccepteerd of niet mogen circuleren in het ontvangende land.",
    setup178: "Beschikbare betaalmethoden",
    setup179: "De website ondersteunt meerdere betaalmethoden, waaronder creditcards/betaalkaarten, WeChat, Alipay, enz. Als u regelmatig betalingen of escrow-afschrijvingen moet doen, kunt u ook het saldo gebruiken om te betalen.",
    setup180: " - Als er een terugbetaling plaatsvindt voor een aankooporder met een creditcard/betaalpas, wordt deze teruggestort op de oorspronkelijke rekening; de terugbetaling voor het opwaarderen van het saldo wordt ook teruggestort op de oorspronkelijke rekening",
    setup181: " - Als er een terugbetaling plaatsvindt voor bestellingen die zijn betaald via WeChat, Alipay, enz., wordt de terugbetaling teruggestort op de oorspronkelijke rekening;",
    setup182: "- Als er een terugbetaling plaatsvindt voor de saldobetaling, wordt dit teruggestort op het rekeningsaldo;",
    setup183: "51shopy Gebruikersprivacybeleid",
    setup184: "De veiligheid van uw persoonlijke informatie is erg belangrijk voor ons en we waarderen uw vertrouwen. Onder geen enkele omstandigheid zullen we uw persoonlijke informatie verkopen of bekendmaken aan derden. We zullen de veiligheid en privacy van alle persoonlijke informatie die u ons verstrekt beschermen en zullen de informatie alleen gebruiken zoals we hier beschrijven. Als u vragen, suggesties of opmerkingen hebt over dit privacybeleid, kunt u op elk moment contact met ons opnemen door het online klantenservicesysteem van 51shopy of het officiële serviceaccount van 51shopy te bezoeken.",
    setup185: "Dit beleid is niet van toepassing op diensten die door andere derden aan u worden geleverd, en het is ook niet van toepassing op diensten waarvoor wij onafhankelijk privacybeleid hebben opgesteld.",
    setup186: "Lees en begrijp dit beleid zorgvuldig voordat u de diensten van 51shopy gebruikt. Uw akkoord met dit privacybeleid betekent dat u de functies die door deze applicatie worden geboden en de benodigde persoonlijke informatie die nodig is om de functies uit te voeren, hebt begrepen.",
    setup187: "De eigendoms- en exploitatierechten van de relevante geregistreerde gebruikersdiensten behoren toe aan ",
    setup188: "1. Welke persoonlijke informatie verzamelen wij?",
    setup189: "U kunt ervoor kiezen om onze website te gebruiken of te bezoeken zonder persoonlijke en transactiegegevens over uzelf te verstrekken, maar u moet zich registreren voor een account om onze volledige service te ervaren. Als u ons uw gegevens verstrekt, stemt u in met de overdracht en opslag van de informatie op onze servers.",
    setup190: "51shopy verzamelt persoonlijke informatie die u verstrekt wanneer u de website gebruikt, waaronder uw naam, contactgegevens, e-mailadres, 51shopy-accountnaam en wachtwoord, en andere informatie die nodig is om een ​​account aan te maken. Naast de persoonlijke informatie die we kunnen verzamelen en verwerken tijdens de registratie, verzamelen, bewaren en verwerken we ook de volgende informatie over onze gebruikers op 51shopy:",
    setup191: "1) Aankoopinformatie",
    setup192: "2) Serviceaccountinformatie",
    setup193: "3) Betalingsinformatie (betalingstijd, betalingsbedrag, betalingskanaal, enz.)",
    setup194: "4) Zoek informatie over de browsegeschiedenis (zoekinhoud, klikgedrag op links, browsegeschiedenis, klikgeschiedenis, enz.)",
    setup195: "5) Cookies en andere computerinformatie",
    setup196: "We zijn een partnerschap aangegaan met Microsoft Clarity en Microsoft Advertising om vast te leggen hoe u onze website gebruikt en ermee omgaat via gedragsstatistieken, heatmaps en sessieherhalingen om onze producten/diensten te verbeteren en op de markt te brengen. Gegevens over sitegebruik worden vastgelegd met behulp van first-party en third-party cookies en andere trackingtechnologieën om de populariteit van producten/diensten en onlineactiviteiten te bepalen. Daarnaast gebruiken we deze informatie voor site-optimalisatie, fraude-/beveiligingsdoeleinden en reclame. Ga voor meer informatie over hoe Microsoft uw gegevens verzamelt en gebruikt naar",
    setup197: "Privacyverklaring van Microsoft",
    setup198: "2. Hoe gebruiken wij uw persoonlijke gegevens?",
    setup199: "We zullen de persoonlijke informatie van geen enkele gebruiker verkopen of bekendmaken en streven ernaar uw informatie en privacy te beschermen. We zullen uw informatie gebruiken om u betere diensten te bieden, waaronder:",
    setup200: "1) Contact met u opnemen via e-mail en u een reeks van onze diensten verlenen, waaronder adviesdiensten, bestelinformatiediensten, pakketinformatiediensten, aftersalesdiensten voor producten, enz.",
    setup201: "2) U via e-mail, interne post, enz. informeren over platformactiviteiten, inclusief het verstrekken van kortingsbonnen, verzendkortingen en speciale promoties, en het verstrekken van mogelijkheden om gebruik te maken van diensten van derden.",
    setup202: "3) Wanneer u zoekt en bladert door de links van onze partnerhandelaren op 51shopy, worden uw 51shopy-gebruikers-ID, gerelateerde operationele gedragingen en informatie (zoekinhoud, linkklikgedrag, browsegeschiedenis, klikweergavegeschiedenis, enz.) verstrekt aan de bron van de operationele gedragslink, zodat wij en onze partnerhandelaren kunnen samenwerken om u hoogwaardige en efficiënte diensten te bieden. U kunt klikken om 51shopy-partnerhandelaren te bekijken (www.taobao.com, www.1688.com).",
    setup203: "Volgens wetten, voorschriften en nationale normen hebben partners in de volgende omstandigheden uw toestemming of toestemming niet nodig om uw persoonlijke gegevens te gebruiken, over te dragen of openbaar te maken:",
    setup204: "1) Volgens de dwingende vereisten van wetten, voorschriften, administratieve en gerechtelijke organen en andere wettelijke verplichtingen;",
    setup205: "2) Voor zover toegestaan ​​door wetten en voorschriften, is het noodzakelijk om het algemeen belang, de veiligheid van eigendommen te beschermen en u of andere 51shopy-gebruikers, 51shopy, 51shopy's filialen of partners te beschermen tegen schade;",
    setup206: "3) Noodzakelijk om de kernfuncties van onze producten en/of diensten te realiseren, of om de diensten te leveren die u nodig hebt;",
    setup207: "4) Uw door u bekendgemaakte persoonsgegevens of andere persoonsgegevens die op wettelijke wijze zijn bekendgemaakt (zoals persoonsgegevens die op wettelijke wijze zijn bekendgemaakt via juridische nieuwsberichten, openbaarmaking van overheidsinformatie of andere kanalen) binnen een redelijke omvang verwerken;",
    setup208: "5) Behandel geschillen of controverses tussen u en anderen volgens uw behoeften;",
    setup209: "6) Voldoen aan de relevante overeenkomsten die met u zijn gesloten (inclusief online elektronische overeenkomsten en bijbehorende platformregels) of andere wettelijke documenten;",
    setup210: "7) Gebruik op basis van maatschappelijke publieke belangen en noodsituaties op het gebied van de volksgezondheid en in overeenstemming met wet- en regelgeving.",
    setup211: "Voor bovenstaande doeleinden hebt u ook het recht om deze melding op elk gewenst moment te annuleren. U kunt inloggen op de 51shopy-website en het zelf instellen in de aangepaste functie.",
    setup212: "Houd er rekening mee dat we uw persoonlijke gegevens niet met adverteerders delen, tenzij we uw toestemming verkrijgen. We zullen geen persoonlijke informatie opvragen of vrijgeven aan kinderen of andere wilsonbekwame personen zonder de toestemming, kennis en aanwezigheid van hun voogden.",
    setup213: "Hierbij erkent, deelt en draagt ​​u geanonimiseerde persoonlijke informatie over en zorgt u ervoor dat de ontvanger van de gegevens het onderwerp van de persoonlijke informatie niet kan herstellen en opnieuw kan identificeren, wat niet het delen, overdragen en openbaar maken van persoonlijke informatie aan de buitenwereld vormt. De opslag en verwerking van dergelijke gegevens vereist geen kennisgeving aan u en uw toestemming.",
    setup214: "We kunnen geautoriseerde partners toevertrouwen om uw persoonlijke informatie te verwerken, zodat zij u bepaalde diensten kunnen leveren of bepaalde functies namens ons kunnen uitvoeren. We zullen de verwerking van uw informatie alleen toevertrouwen voor de legitieme, juiste, noodzakelijke, specifieke en duidelijke doeleinden die in dit beleid worden vermeld, en geautoriseerde partners hebben alleen toegang tot de informatie die nodig is om hun taken uit te voeren. 51shopy zal uw e-mailadres, 51shopy-website-accountnaam en wachtwoord, contactgegevens en andere privé-informatie niet aan onze partners verstrekken.",
    setup215: "3. Hoe lang bewaren wij uw gegevens?",
    setup216: "Zodra u succesvol een 51shopy-account hebt geregistreerd, slaan wij uw persoonlijke gegevens permanent op. Als u uw account wilt annuleren of uw persoonlijke gegevens wilt verwijderen, neem dan contact op met de online klantenservice.",
    setup217: "Op grond van de AVG zijn verwerkingsverantwoordelijken en verwerkers verplicht om alle persoonsgegevens na afloop van de dienstverlening of het verstrijken van het contract of de overeenkomst terug te geven of te verwijderen, tenzij er een wettelijke verplichting bestaat om de gegevens te bewaren.",
    setup218: "4. Hoe beschermen wij uw persoonlijke gegevens",
    setup219: "We zullen alle redelijke en haalbare maatregelen nemen om uw persoonlijke informatie te beschermen. We zullen alle redelijke en haalbare maatregelen nemen om ervoor te zorgen dat er geen irrelevante persoonlijke informatie wordt verzameld.",
    setup220: "5. Beleidsupdate",
    setup221: "Om u een betere product- en service-ervaring te bieden, werken we voortdurend aan het verbeteren van onze producten, services en technologieën. Wanneer nieuwe services en bedrijfsprocessen veranderen, kunnen we ons privacybeleid bijwerken om u te informeren over specifieke wijzigingen. Lees deze pagina tijdig en volg het laatste beleid op de pagina. Zodra het laatste beleid is vrijgegeven, is het bindend voor u.",
    setup222: "6. Neem contact met ons op",
    setup223: "Als u vragen heeft over deze privacyverklaring, neem dan contact op met: ",
    setup224: "Lees de 51shopy Servicevoorwaarden zorgvuldig door voordat u zich registreert als gebruiker en zorg ervoor dat u deze voorwaarden volledig begrijpt. Lees de 51shopy Servicevoorwaarden zorgvuldig door en kies ervoor om ze wel of niet te accepteren, met name de voorwaarden voor vrijstelling of beperking van aansprakelijkheid, toepasselijk recht en geschillenbeslechting. Tenzij u deze 51shopy Servicevoorwaarden accepteert, hebt u geen recht om u te registreren, in te loggen of 51shopy-services te gebruiken. Uw registratie, login en gebruik worden beschouwd als uw acceptatie van de 51shopy Servicevoorwaarden en uw instemming om gebonden te zijn aan de 51shopy Servicevoorwaarden.",
    setup225: "De 51shopy Servicevoorwaarden bepalen de rechten en plichten van u en 51shopy met betrekking tot de 51shopy-services (hierna te noemen 'Services'). De 51shopy Servicevoorwaarden kunnen op elk moment door 51shopy worden bijgewerkt. De bijgewerkte 51shopy Servicevoorwaarden vervangen de oorspronkelijke voorwaarden zodra deze zijn gepubliceerd en bekendgemaakt zonder verdere kennisgeving. U kunt de nieuwste versie van de 51shopy Servicevoorwaarden bekijken op het 51shopy-platform. Het wordt ook aanbevolen om op de hoogte te blijven van de bijgewerkte 51shopy Servicevoorwaarden om onnodige misverstanden en geschillen te voorkomen. Nadat de 51shopy Servicevoorwaarden zijn gewijzigd, stop dan onmiddellijk met het gebruik van de door 51shopy geleverde services als u de gewijzigde voorwaarden niet accepteert. Uw voortdurende gebruik van de door 51shopy geleverde services wordt beschouwd als acceptatie van de gewijzigde 51shopy Servicevoorwaarden.",
    setup226: "1. Toepassingsgebied van deze Servicevoorwaarden",
    setup227: "De eigendoms- en exploitatierechten van de relevante geregistreerde gebruikersdiensten behoren toe aan . De geleverde diensten moeten worden geïmplementeerd in overeenstemming met de door haar uitgegeven serviceregels, voorwaarden en operationele specificaties, wat ook betekent dat de relevante gebruikers een overeenkomst hebben bereikt met 51shopy en alle servicevoorwaarden hebben geaccepteerd.",
    setup228: "2. Informatieverzameling en gebruik",
    setup229: "Wanneer u gebruikmaakt van de diensten van 51shopy, moeten wij mogelijk de volgende twee soorten persoonlijke gegevens van u verzamelen en gebruiken:",
    setup230: "1. Om u de basisfuncties van onze diensten te kunnen bieden, moet u ons toestemming geven om de benodigde informatie te verzamelen en te gebruiken. Als u weigert de bijbehorende informatie te verstrekken, kunt u zich niet registreren, inloggen of onze diensten normaal gebruiken;",
    setup231: "2. Om u extra functies van onze diensten te bieden, kunt u ervoor kiezen om akkoord te gaan of het oneens te zijn met de informatie die wij verzamelen en gebruiken. Als u weigert om te verstrekken, kunt u de relevante extra functies niet gebruiken of de functionele effecten bereiken die wij beogen te bereiken, en het heeft geen invloed op uw gebruik van onze basisfuncties.",
    setup232: "Wij beschermen uw recht om te weten en recht om te kiezen tijdens het installatie- of gebruiksproces in overeenstemming met de wet. Wanneer u 51shopy-services gebruikt, vereisen services met functies die op uw apparaat worden aangeboden uw voorafgaande toestemming. Na uw bevestiging heeft 51shopy het recht om noodzakelijke hulpfuncties in te schakelen, zoals het verzamelen van geografische locaties, het lezen van het adresboek, het gebruiken van de camera en het inschakelen van opnameservices.",
    setup233: "De verzamelde en gebruikte informatie omvat, maar is niet beperkt tot, de naam van de gebruiker, contactgegevens en andere basisinformatie. De gebruiker stemt ermee in dat het gebruik van deze informatie onderworpen is aan de bepalingen van Artikel 3 'Bescherming van gebruikersinformatie.",
    setup234: "3. Bescherming van gebruikersinformatie",
    setup235: "Wij zullen uw persoonlijke gegevens niet aan derden bekendmaken of onthullen, tenzij:",
    setup236: "1. Delen noodzakelijk om wettelijke verplichtingen na te komen;",
    setup237: "2. Delen met uw toestemming;",
    setup238: "4. Gebruikersrechten en -plichten",
    setup239: "1. U hebt het recht om in te loggen op de website van 51shopy om uw persoonlijke gegevens te bekijken, te corrigeren en aan te vullen.",
    setup240: "2. U hebt het recht om contact op te nemen met de online klantenservice om uw account te annuleren. Nadat u uw account hebt geannuleerd, stoppen we met het leveren van diensten aan u en verwijderen of anonimiseren we uw persoonlijke gegevens in overeenstemming met de vereisten van de relevante wetten.",
    setup241: "3. In bepaalde bedrijfsfuncties kunnen we beslissingen nemen die uitsluitend gebaseerd zijn op niet-menselijke geautomatiseerde besluitvormingsmechanismen, waaronder algoritmen. Als deze beslissingen uw wettelijke rechten beïnvloeden, kunt u contact met ons opnemen via de klantenservice.",
    setup242: "4. Alle informatie die u aan 51shopy verstrekt, moet waar, nauwkeurig en niet misleidend zijn.",
    setup243: "U begrijpt en gaat ermee akkoord dat u verplicht bent de authenticiteit en geldigheid van de door u verstrekte informatie te handhaven.",
    setup244: "5. U mag uw geregistreerde account of 51shopy-services niet gebruiken om inhoud te creëren, uploaden, kopiëren, publiceren of verspreiden die de normale werking van 51shopy verstoort of inbreuk maakt op de legitieme rechten en belangen van andere gebruikers of derden.",
    setup245: "6. U mag geen enkel deel van de 51shopy-service of de inhoud die via de 51shopy-service wordt gebruikt of verkregen, kopiëren, plagiëren, verkopen, wederverkopen of gebruiken voor andere commerciële doeleinden.",
    setup246: "7. U bent als enige verantwoordelijk voor de authenticiteit, wettigheid, nauwkeurigheid en geldigheid van alle informatie die via uw 51shopy-account of 51shopy-services wordt verzonden. Elke wettelijke aansprakelijkheid met betrekking tot informatie die u verzendt, wordt door u gedragen en heeft niets te maken met 51shopy. U compenseert alle verliezen die worden veroorzaakt aan 51shopy of een derde partij, en 51shopy behoudt zich het recht voor om relevante gebruikers en gebruikers aansprakelijk te stellen.",
    setup247: "8. U bent volledig verantwoordelijk voor de gevolgen van alle acties die u onder uw account onderneemt (inclusief maar niet beperkt tot het online ondertekenen van verschillende overeenkomsten, het publiceren van informatie, het kopen van goederen en diensten en het vrijgeven van informatie).",
    setup248: "5. Informatieopslag",
    setup249: "51shopy' heeft geen bovengrens voor de hoeveelheid verzonden informatie. We hebben redelijke en haalbare beveiligingsmaatregelen genomen die voldoen aan de industrienormen om uw informatie te beschermen en te voorkomen dat persoonlijke informatie zonder toestemming wordt geopend, bekendgemaakt, gebruikt, gewijzigd, beschadigd of verloren gaat. Bescherm uw persoonlijke informatie ook op de juiste manier en verstrek deze alleen aan anderen als dat nodig is. Vertrouw niet op andere handelstools om diefstal van informatie of zelfs online fraude te voorkomen.",
    setup250: "6. Disclaimer van aansprakelijkheid",
    setup251: "1.51shopy zal zijn best doen om de werkelijke situatie te reproduceren met de verstrekte productinformatie, maar vanwege de invloed van verschillende factoren, zoals de omgeving, de opnamehoek, verschillen in apparatuur, enz. tijdens het productopnameproces, kunnen we niet garanderen dat het product exact hetzelfde is als het echte product.",
    setup252: "2.51shopy koopt aangewezen producten op basis van het door de gebruiker opgegeven platform. Als het door u opgegeven platform niet op voorraad is, de prijs verandert, de levering vertraagd is, het daadwerkelijke product niet overeenkomt met de productinformatie op de website, het product abnormaal is of andere overmachtsfactoren leiden tot het onvermogen om normaal te kopen, zullen wij tijdig met u communiceren. Daarom aanvaardt '51shopy' geen enkele verantwoordelijkheid voor de verliezen die u lijdt.",
    setup253: "3. Als de producten die u bij 51shopy hebt gekocht, problemen met de aftersales veroorzaken (zoals niet op voorraad, schade, defecten, enz.), zullen wij deze tijdig voor u afhandelen.",
    setup254: "4. 51shopy aanvaardt geen enkele verantwoordelijkheid voor verliezen of gevolgen die worden veroorzaakt door uw proactieve openbaarmaking van uw 51shopy-account of door aanvallen, fraude, enz. door anderen. U dient compensatie te zoeken bij de inbreukmaker via juridische middelen of andere middelen.",
    setup255: "7. Verboden gedrag",
    setup256: "U mag de diensten van 51shopy niet gebruiken voor de volgende activiteiten:",
    setup257: "(1) Schending van een wet, statuut, besluit of regeling.",
    setup258: "(2) De volgende transacties zijn hierbij betrokken:",
    setup259: "(a) verdovende middelen, steroïden, bepaalde gecontroleerde drugs of andere producten die de veiligheid van de consument in gevaar kunnen brengen;",
    setup260: "(b) drugsattributen;",
    setup261: "(c) Sigaretten;",
    setup262: "(d) ongeoorloofde cannabis of andere psychoactieve planten;",
    setup263: "(e) op abonnement gebaseerde voeding, vitamines, supplementen, kruiden en natuurlijke gezondheidsproducten;",
    setup264: "(f) materiaal dat anderen aanzet, aanzet, helpt of instrueert om zich bezig te houden met illegale activiteiten;",
    setup265: "(g) gestolen items, inclusief digitale en virtuele items;",
    setup266: "(h) materialen die aanzetten tot haat, geweld, racisme of andere vormen van onverdraagzaamheid of criminele activiteiten uitbuiten;",
    setup267: "(i) als obsceen beschouwd;",
    setup268: "(j) materiaal dat inbreuk maakt op of in strijd is met auteursrecht, handelsmerk, publiciteit of privacy of enig ander eigendomsrecht onder de wetten van enig rechtsgebied;",
    setup269: "(k) bepaalde pornografische materialen of diensten;",
    setup270: "(l) munitie, wapens of bepaalde onderdelen of toebehoren van wapens, of",
    setup271: "(m) Bepaalde wapens of messen die worden gereguleerd door de toepasselijke wetgeving.",
    setup272: "(3)Gerelateerd aan de volgende transacties:",
    setup273: "(a) Openbaarmaking van persoonlijke informatie van derden in strijd met relevante wetten;",
    setup274: "(b) piramidespelen, Ponzi-spelen, matrixspelen, andere snel-rijk-worden-spelen of bepaalde multi-level downline-spelen ondersteunt;",
    setup275: "(c) transacties met betrekking tot de aankoop van lijfrentes of loterijcontracten, systemen voor de aankoop van prepaid deposito's, offshore bankieren of transacties om creditcard-schulden te financieren of herfinancieren;",
    setup276: "(d) iets verkopen voordat de verkoper er controle over heeft of het in bezit heeft;",
    setup277: "(e) betalingsverwerkers innen betalingen namens handelaren;",
    setup278: "(f) in verband met de verkoop van reischeques of postwissels;",
    setup279: "(g) met betrekking tot valutawissel- of cheque-incasso-operaties;",
    setup280: "(h) bepaalde kredietreparatie- of schuldenregelingsdiensten, creditcardtransacties of verzekeringsactiviteiten omvat, of",
    setup281: "(i) het doen of ontvangen van betalingen in verband met omkoping of corruptie.",
    setup282: "(4) Het betreft de verkoop van producten of diensten waarvan overheidsinstanties hebben vastgesteld dat ze frauduleus kunnen zijn.",
    setup283: "U bent wettelijk aansprakelijk voor uw gebruik van de diensten van 51shopy, met inbegrip van maar niet beperkt tot compensatie voor verliezen voor de partij die inbreuk heeft gemaakt. Nadat 51shopy voor het eerst wettelijke aansprakelijk is, zoals administratieve boetes of compensatie voor inbreuken veroorzaakt door gebruikersgedrag, betaalt u 51shopy een gelijk bedrag aan compensatie en andere verliezen die 51shopy als gevolg daarvan heeft geleden.",
    setup284: "8. Schadevergoedingsaansprakelijkheid",
    setup285: "1. Als uw acties ertoe leiden dat 51shopy en/of haar filialen verliezen lijden (inclusief directe economische verliezen, verlies van goodwill en indirecte economische verliezen zoals compensatie, schikking, advocaatkosten, behoudverzekering, proceskosten, enz.), dient u 51shopy en/of haar filialen te compenseren voor alle verliezen.",
    setup286: "2. Als uw acties ertoe leiden dat 51shopy en/of haar filialen worden aangeklaagd door een derde partij (inclusief maar niet beperkt tot verkopers op Taobao, 1688 en andere platforms), kunnen 51shopy en/of haar filialen alle verliezen op u verhalen nadat ze verplichtingen zijn aangegaan, zoals een financiële compensatie aan de derde partij.",
    setup287: "9. Toepasselijk recht en jurisdictie",
    setup288: "1. Deze Serviceovereenkomst en elke afzonderlijke overeenkomst waarbij wij u diensten verlenen, worden beheerst door en geïnterpreteerd in overeenstemming met de wetten van Hongkong.",
    setup289: "2. Alle geschillen die voortvloeien uit uw gebruik van 51shopy-diensten en geschillen met betrekking tot 51shopy-diensten worden opgelost door middel van onderhandelingen tussen 51shopy en u. Als de onderhandelingen mislukken, kan elke partij een rechtszaak aanspannen bij de rechtbank met jurisdictie over de plaats waar deze overeenkomst is ondertekend.",
    setup290: "Hieronder vindt u het uitgaande magazijn (verzonden naar het magazijn van de logistieke dienstverlener) / het ophaalschema van de logistieke dienstverlener, uitsluitend ter referentie (het werkelijke schema is afhankelijk van de afspraken van elke logistieke dienstverlener):",
    setup291: "Pakket bezorg-/ophaaltijd:",
    setup292: "Wanneer de pakketstatus in het magazijn van 51shopy 'Verpakt' is, regelen het magazijn en het logistieke bedrijf de levering/afhaling binnen een vastgestelde tijd (het logistieke bedrijf is gesloten in het weekend en op feestdagen en de afhaling wordt uitgesteld).",
    setup293: "Route",
    setup294: "Verzend-/ophaalschema (Beijing-tijd)",
    setup295: "GD-EMS",
    setup296: "Afhalen van maandag tot zondag",
    setup297: "GD-EUB",
    setup298: "Afhalen van maandag tot zondag",
    setup299: "GD-E-EMS",
    setup300: "Afhalen van maandag tot zondag",
    setup301: "EUB-T",
    setup302: "Afhalen van maandag tot zondag",
    setup303: "DHL Express",
    setup304: "Afhalen van maandag tot en met zaterdag",
    setup305: "DHL Zware Vracht Standaard Express",
    setup306: "Afhalen van maandag tot en met zaterdag",
    setup307: "Europese DHL Special Line",
    setup308: "Verzending van maandag tot en met zondag (afgeleverd bij het magazijn van de logistieke dienstverlener)",
    setup309: "Amerikaanse lijn (klein)",
    setup310: "Verzending van maandag tot en met zondag (afgeleverd bij het magazijn van de logistieke dienstverlener)",
    setup311: "Britse lijn (klein)",
    setup312: "Verzending van maandag tot en met zondag (afgeleverd bij het magazijn van de logistieke dienstverlener)",
    setup313: "Koreaanse EMS",
    setup314: "Elke dag verzending vanuit ons magazijn",
    setup315: "PDB Postpakket",
    setup316: "Haibao",
    setup317: "Europese Spoorwegen",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "Aramex dedicated lijn",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "Britse lijn",
    setup334: "NH-EMS",
    setup335: "Europese duty-free lijn",
    setup336: "Amerikaanse lijn",
    setup337: "YTO-expressie",
    setup338: "SF Express",
    setup339: "51shopy is een platform dat Chinese productwinkel- en doorstuurdiensten levert, en gebruikers voorziet van productinformatiezoek-, winkel- en doorstuurdiensten. Gedurende deze periode biedt 51shopy basisproductinspectiediensten, communicatiebevestiging met handelaren en aftersalesdiensten om uw wettelijke rechten en belangen te beschermen en uw winkelervaring te garanderen.",
    setup340: "Als u vaststelt dat de gekochte goederen namaak of van mindere kwaliteit zijn, neem dan contact op met onze klantenservice of stuur een e-mail naar",
    setup341: "1. Ontvangst en inspectie: Nadat de productkwaliteit is gecontroleerd en in het magazijn van 51shopy is geplaatst, of nadat u het pakket hebt ontvangen, en u kwaliteitsproblemen met het product constateert of twijfelt aan de authenticiteit, neem dan zo snel mogelijk contact op met de klantenservice en verstrek relevant bewijs.",
    setup342: "2. Klachtenmaterialen: verstrek het bestelformulier, betalingsbewijs, productbeschrijving en bewijs van namaak- of inferieure producten.",
    setup343: "3. Nadat ons klantenserviceteam uw klachtmateriaal heeft ontvangen, zal het de details met u bespreken en u helpen bij de communicatie met de verkoper om het probleem op te lossen en te streven naar het verdedigen van uw wettelijke rechten.",
    setup344: "Houd er rekening mee dat vanwege de authenticiteit van het product verdere professionele evaluatie en juridische procedures vereist kunnen zijn. Als een professioneel evaluatiebureau vereist is, zijn de evaluatiekosten voor uw rekening. Om de rechten en belangen van alle partijen te beschermen, raden wij u aan om bij aankoop formele kanalen en gerenommeerde verkopers te kiezen om het risico op het kopen van namaakgoederen te verkleinen.",
    setup345: "Wat is de 14-daagse retour-/ruilgarantie?",
    setup346: "De retour- en omruilgarantie van vijf dagen is een speciale aftersalesservice (inclusief de service zelf en technische ondersteuning) die door externe platformverkopers aan consumenten wordt geleverd. Binnen 14 dagen nadat de goederen zijn ondertekend (dat wil zeggen binnen 14 dagen nadat de goederen in opslag zijn geplaatst), kunnen kopers de gekochte goederen retourneren of omruilen volgens deze regel en de relevante regels die door het externe platform zijn uitgegeven.",
    setup347: "Hoe bepaal ik of een product in aanmerking komt voor de retour-/ruilgarantie?",
    setup348: "Producten komen ofwel 'in aanmerking' voor de gratis retour- en omruilservice van 14 dagen, ofwel 'niet in aanmerking' voor de gratis retour- en omruilservice van 14 dagen",
    setup349: "Is het beschikbaar?",
    setup350: "Typen",
    setup351: "Bijvoorbeeld",
    setup352: "Niet beschikbaar",
    setup353: "Vastgesteld op basis van de informatie die door de verkoper is verstrekt. Als we dit niet kunnen bevestigen, onderhandelen we met de verkoper over de retour/ruil, maar het uiteindelijke resultaat is afhankelijk van de beslissing van de verkoper.",
    setup354: "Aanpassing",
    setup355: "Op maat gemaakte ontwerpproducten",
    setup356: "Ondersteunt expliciet geen retourzendingen en omruilingen",
    setup357: "Promoteer defecte producten",
    setup358: "Producten waarvan de verpakking, etiketten en accessoires op verzoek van de gebruiker zijn verwijderd",
    setup359: "Kledinglabel is afgescheurd",
    setup360: "Kranten en tijdschriften",
    setup361: "Geabonneerde boeken en tijdschriften",
    setup362: "Tweedehands producten",
    setup363: "Producten buiten het vasteland van China",
    setup364: "Producten gekocht uit het buitenland en Hong Kong en Macau",
    setup365: "Ondergoed",
    setup366: "Ondergoed, sokken, leggings",
    setup367: "Producten voor volwassenen",
    setup368: "Overige zaken gespecificeerd door de verkoper",
    setup369: "Voldoe aan de regels van de verkoper",
    setup370: "Eten",
    setup371: "Koekjes, snoepjes, etc.",
    setup372: "Boeken (≥15 boeken)",
    setup373: "Niet minder dan 15 boeken",
    setup374: "Artikelen die zijn geopend en moeten voldoen aan de 'speciale normen' voor retourverpakkingen.",
    setup375: "Voor afdichtingsproducten, zie de bijgevoegde tabel",
    setup376: "Beschikbaar",
    setup377: "Voor retour-/ruilverzoeken die binnen 14 dagen na ontvangst worden ingediend, zullen wij deze verwerken volgens de standaardprocedures.",
    setup378: "Wanneer het product aan alle volgende vereisten voldoet:",
    setup379: "1. De verkoper biedt een retourgarantie;",
    setup380: "2. In een doorverkoopbare staat zoals vereist door de verkoper;",
    setup381: "3. De opslagtijd is niet langer dan 14 dagen.",
    setup382: "Voor producten die gratis verzending aanbieden, bent u verantwoordelijk voor de verzendkosten wanneer u het product retourneert. Voor producten die geen gratis verzending aanbieden, bent u verantwoordelijk voor de verzendkosten wanneer de verkoper het product naar ons magazijn stuurt en wanneer u het product retourneert aan de verkoper.",
    setup383: "Hoe vraag ik een retour-/ruilservice aan",
    setup384: "Binnen 14 dagen nadat de orderstatus is gewijzigd in 'Inventaris' (berekend vanaf het volgende uur nadat de status is gewijzigd in 'Inventaris', 14 dagen = 336 uur), kunt u op de pagina een aanvraag indienen voor retour- en omruilservice. Aanvragen worden mogelijk niet meer geaccepteerd na de tijdslimiet.",
    setup385: "Voorzorgsmaatregelen en veelgestelde vragen",
    setup386: "Opmerkingen:",
    setup387: "Het totale restitutie-/ruilbedrag is gebaseerd op de werkelijke productprijs die u hebt betaald",
    setup388: "We kunnen producten alleen voor u retourneren/ruilen als de verkoper hiermee akkoord gaat",
    setup389: "Zorg ervoor dat er na het aanvragen van de retour-/ruilservice voldoende saldo op uw rekening staat om de retourverzend- en servicekosten te betalen.",
    setup390: "Raadpleeg de onderstaande tabel voor de retourverpakkingsvereisten van sommige producten. Als niet aan de vereisten wordt voldaan, kunt u het product niet retourneren/ruilen.",
    setup391: "Speciale normen",
    setup392: "Productcategorie",
    setup393: "Speciale normen",
    setup394: "Nieuwe sportschoenen",
    setup395: "Antidiefstalsluitingen (indien aanwezig) en anti-manipulatiestickers zijn niet doorgeknipt/verwijderd en zijn volledig functioneel.",
    setup396: "Wasmiddel / Tampon / Papier / Parfum",
    setup397: "Verzegelde verpakkingen voor eenmalig gebruik van persoonlijke verzorgingsproducten moeten, indien van toepassing, verzegeld blijven.",
    setup398: "Haarverzorging/Pruiken",
    setup399: "Eenmalig te gebruiken, verzegelde verpakkingen voor haarverzorgingsproducten (indien van toepassing) moeten verzegeld blijven.",
    setup400: "Huidverzorging/Lichaamsverzorging/Essentiële oliën",
    setup401: "De verzegelde wegwerpverpakking van het product (indien aanwezig) moet verzegeld blijven",
    setup402: "Cosmetica/Parfums/Schoonheidshulpmiddelen",
    setup403: "Digitale producten/huishoudelijke apparaten (exclusief camera's en grote apparaten)",
    setup404: "1. De internettoegangslicentie is niet beschadigd (vernietigd).",
    setup405: "2. Geen waterschade.",
    setup406: "Digitale camera/SLR-camera/camera",
    setup407: "De ontspanknop van een spiegelreflexcamera mag niet vaker dan 20 keer worden ingedrukt.",
    setup408: "Grote apparaten",
    setup409: "1. LCD-tv, airconditioning: Nog niet aan de muur geïnstalleerd, eenvoudige foutopsporing is beschikbaar.",
    setup410: "2. Wasmachine: is nog niet met water gebruikt.",
    setup411: "Modellen / Anime-randapparatuur / Anime-randapparatuur / Rollenspelproducten / Bordspellen",
    setup412: "De tape en plastic verzegelingen (indien aanwezig) op modellen, beeldjes, soldatenmodellen, BJD en andere producten kunnen niet worden verwijderd.",
    setup413: "Elektronische componenten",
    setup414: "1. Lassen is verboden.",
    setup415: "2. Het geïntegreerde circuit is nog nooit op een IC-basis gemonteerd.",
    setup416: "3. Wegwerpverpakkingen met verbruiksartikelen zoals thermische pasta/thermische pasta, elektronische lijm/pottinglijm/kit/kleefstof, geleidende lijm, geleidende inkt, enz. moeten gesloten blijven.",
    setup417: "Subcategorie 'Game Software' onder de categorie op het eerste niveau 'Videogames/Accessoires/Games/Gamegidsen",
    setup418: "Voeding voor huisdieren, gezondheidsproducten en medicijnen onder de categorie 'Huisdieren/Voeding en benodigdheden voor huisdieren' op het eerste niveau",
    setup419: "Boeken/Tijdschriften",
    setup420: "1. De wegwerpverpakking van het product (indien aanwezig) moet verzegeld blijven",
    setup421: "2. Het product mag geen vouw-, water-, vuil-, inkt- of leesvlekken vertonen.",
    setup422: "Secundaire categorie 'Diergezondheidsproducten/Diergeneesmiddelen' onder de primaire categorie 'Veeteelt/Landbouwproducten'",
    setup423: "Verzegelde verpakkingen voor eenmalig gebruik (indien van toepassing) voor producten zoals voedsel (inclusief supplementen), cosmetica, medische hulpmiddelen, anticonceptiemiddelen, persoonlijke verzorgingsproducten, producten voor volwassenen, babyluiers, boeken en audiovisuele producten moeten verzegeld blijven.",
    setup424: "'Verzegeling' verwijst naar de verzegeling of plastic verpakking die door de fabrikant op de productverpakking wordt gebruikt.",
    setup425: "Veelgestelde vragen:",
    setup426: "1. Wat moet ik doen als een bestelling die niet onder de 'Retour- en omruilgarantie' valt, problemen heeft met de aftersales?",

    setup427: "Wanneer er kwaliteitsproblemen zijn met het product, zal 51shopy dit verifiëren bij de verkoper op basis van de werkelijke situatie, een definitieve oplossing formuleren en de gebruiker op de hoogte stellen. Als er geen kwaliteitsproblemen zijn met het product, kunnen er volgens de regels van het platform van derden geen retour- en omruilservices worden verleend. 51shopy zal zijn best doen om met de verkoper te communiceren om de rechten en belangen van gebruikers te beschermen.",
    setup428: "2. Wie is verantwoordelijk voor de verzending bij gebruik van de 'Retour-/ruilgarantie'? ",
    setup429: "Voordat u een aanvraag indient voor retour- en omruilservice, moet het product gloednieuw zijn en voldoen aan de wederverkoopvoorwaarden. Als het product geen kwaliteitsproblemen heeft, zijn de verzendkosten voor rekening van de gebruiker. Als het product kwaliteitsproblemen heeft, draagt ​​de verkoper de verzendkosten nadat de gebruiker de aanvraag heeft ingediend.",
    setup430: "3. Als de orderstatus 'niet verzonden' is, zijn er dan kosten verbonden aan de retourservice?",
    setup431: "Maak je geen zorgen, in dit geval worden er geen kosten in rekening gebracht. Je betaalt alleen als het retourverzoek aan drie voorwaarden voldoet: ten eerste, het product heeft geen kwaliteitsproblemen. Ten tweede, het product is al op voorraad in het magazijn. Ten derde, je hebt het aantal gratis retourzendingen deze maand opgebruikt. Daarom brengen we je niets in rekening als het product niet is verzonden.",
    setup432: "E-mail:",
    setup433: "Telefoon: +85251387262",
    setup434: "Adres: Kamer 341, 3/F, Openbaar Industrieel Gebouw, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",
    setup435: "Aangedreven door 51shopy - Space Network Technology Co., Ltd.",
    setup436: "U helpen bij de verwerking",
    setup437: "Gisteren's hete uitverkoop",
    setup438: "Hete verkoop",
    setup439: "Verkocht",
    setup440: "Betaling mislukt",
    setup441: "Wachten op betaling van verzendkosten",
    setup442: "Port betaald, wacht op bevestiging van de bank",
    setup443: "Port betaald",
    setup444: "Specificaties",
    setup445: "Werkelijke betaling",
    setup446: "Het wordt aanbevolen dat u goed nadenkt voordat u een bestelling annuleert. Het platform is niet verantwoordelijk voor het annuleren van een bestelling!",
    setup447: "Betaling wijzigen",
    setup448: "Portokosten betalen",
    setup449: "Mall-bestelling",
    setup450: "Meer",
    setup451: "Webwinkel",
    setup452: "Aankopen",
    setup453: "Vrijgeven",
    setup454: "Verkopen",
    setup455: "Geschiedenis",
    setup456: "Aankooporder",
    setup457: "Te betalen bedrag",
    setup458: "Ga naar de winkel",
    setup459: "Meer bekijken",
    setup460: "Instorten",
    setup461: "Binnenkomen",
    setup462: "Het product is uitverkocht.",
    setup463: "Wij raden de volgende vergelijkbare producten aan",
    setup464: "Vergelijkbare producten",
    setup465: "Vrijwaring",
    setup467: "Verpakking verwijst naar de originele verpakking van het product. Bij inspectie wordt de logistieke verpakking verwijderd, behalve het product zelf. Om schade aan het product te voorkomen, worden de benodigde beschermende verpakkingsmaterialen bewaard. Wij zijn niet verantwoordelijk als u verzoekt om de verpakking te verwijderen.",
    setup468: "Binnenlandse uitgebreide vracht Voor goederen van dezelfde verkoper wordt de vrachtafwijking door ons gecorrigeerd.",
    setup469: "Voor elk product maken we gratis 3-7 foto's voor u. Als u aanvullende vereisten hebt voor prachtige fotoservices, kunnen we een kleine servicevergoeding in rekening brengen.",
    setup470: "Gepersonaliseerde producten kunnen niet worden geretourneerd of geruild.",
    setup471: "Voor producten die door de verkoper zijn goedgekeurd voor retournering en omruiling, kunt u binnen 14 dagen nadat de orderstatus is gewijzigd in 'Op voorraad' een aanvraag voor retournering en omruiling indienen. Wanneer u een retournering en omruiling aanvraagt, moet u een verwerkingsvergoeding van ongeveer US$ 0,75 en binnenlandse verzendkosten voor elke verschillende productretournering betalen, het totale bedrag is ongeveer US$ 3.",
    setup472: "All",
    setup473: "Postroute",
    setup474: "Verzendkosten",
    setup475: "De lengte-, breedte- en hoogte-informatie van het pakket is vereist",
    setup476: "Transporttijd",
    setup477: "dag",
    setup478: "Belastingvrij",
    setup479: "Kan verzekerd worden",
    setup480: "Verz. schatten",
    setup481: "Wachtwoordregister ophalen",
    setup482: "Handelaar",
    setup483: "Alstublieft",
    setup484: "Betaal, anders wordt de bestelling geannuleerd",
    setup485: "Totale prijs van goederen",
    setup486: "Bedrag",
    setup487: "Nu betalen",
    setup488: "Saldo is onvoldoende, laad op en betaal",
    setup489: "Geen geschikte betaalmethode? U kunt eerst proberen te betalen met uw saldo",
    setup490: "Al op voorraad",
    setup491: "Vracht is geciteerd",
    setup492: "Verzendkosten betaald",
    setup493: "Niet op voorraad",
    setup494: "Doorgaan met betalen",
    setup495: "Internationaal logistiek ordernummer",
    setup496: "Binnenlands logistiek ordernummer",
    setup497: "Uw browser ondersteunt geen HTML5-videospeler.",
    setup498: "Ondersteunt alleen het uploaden van afbeeldingen in PNG- en JPEG-formaat!",
    setup499: "Voltooid",
    setup500: "terug",
    setup501: "U hebt geen toestemming om deze pagina te openen",
    setup502: "Transportberekening",
    setup503: "Werk samen met veel logistieke bedrijven om de meest gunstige kortingen te bieden",
    setup504: "Verz. schatten",
    setup505: "Zoeken naar producten",
    setup506: "Bekijk producten op basis van zoekcriteria",
    setup507: "Basisgegevens",
    setup508: "Voer de Engelse naam in",
    setup509: "Voer de Chinese naam in",
    setup510: "Geüploade video's kunnen alleen in MP4-, WebM- of OGG-formaat zijn!",
    setup511: "De geüploade video mag niet groter zijn dan 2 MB!",
    setup512: "Videoduur kan niet langer zijn dan",
    setup513: "seconden",
    setup514: "Kan de videoduur niet verkrijgen, controleer of het videobestand beschadigd is",
    setup515: "gegevens",
    setup516: "",
    setup517: "Voer sku in",
    setup518: "Voer de hoeveelheid in",
    setup519: "Voer de prijs in",
    setup520: "Voer de productgegevens in het Engels in",
    setup521: "Voer de Chinese productgegevens in",
    setup522: "Vereenvoudigd Chinees",
    setup523: "Spaans",
    setup524: "Portugees",
    setup525: "Nederlands",
    setup526: "Pools",
    setup527: "Duits",
    setup528: "Frans",
    setup529: "Italiaans",
    setup530: "Meerdere specificaties inschakelen",
    setup531: "Prijs (CNY)",
    setup532: "Spec.Foto's Toev.",
    setup533: "Spec.Waarde+",
    setup534: "① Dubbelklik om te wijzigen, sleep om de volgorde aan te passen",
    setup535: "Specificaties toevoegen",
    setup536: "Batch-instellingen",
    setup537: "Publiceer op de PC-kant",
    setup538: "Naam",
    setup539: "Productvideo uploaden",
    setup540: "tijd voor binnenkomst magazijn",
    setup541: "tijd voor vertrek magazijn",
    setup543: "Mijn release",
    setup544: "Gelieve u te authenticeren als handelaar alvorens het product te publiceren",
    setup545: "Ga naar de pc-kant om het product te publiceren",
    setup546: "bestemming",
    setup547: "Verenigde Staten van Amerika",
    setup548: "Gewicht (gram)",
    setup549: "Productcategorie",
    setup550: "Selecteer een categorie",
    setup551: "lengte",
    setup552: "breedte",
    setup553: "hoogte",
    setup554: "VRAAG",
    setup555: "omvattend",
    setup556: "Kan worden verzekerd",
    setup557: "belastingvrij",
    setup558: "verzendkosten",
    setup559: "Informatie over de lengte, breedte en hoogte van het pakket nodig",
    setup560: "Transporttijd",
    setup561: "dagen",
    setup562: "Annuleer ustd-betaling succesvol!",
    setup563: "dagHerinnering: Selecteer uw land van bestemming en het systeem zoekt naar beschikbare routes op die locaties",
    setup564: "Pakketbeperkingen",
    setup565: "Minimumgewichtslimiet:",
    setup566: "Maximumgewichtslimiet:",
    setup567: "Volumegewichtsfactureringsregels:",
    setup568: "Groottelimiet:",
    setup569: "Kan niet verzenden",
    setup570: "Kan verzenden",
    setup571: "Kostennormen:",
    setup572: "Gewichtseenheid",
    setup573: "Eenheidsprijs",
    setup574: "Douanekosten",
    setup575: "Brandstofkosten",
    setup576: "Operatiekosten",
    setup577: "De kredietlimiet van deze bank is onvoldoende, dus u kunt deze bank niet selecteren!",
    setup578: "Het saldo van 51coins is onvoldoende, laad op!",
    setup579: "opmerking",
    setup580: "Selecteer het product dat u wilt verwijderen!",
    setup581: "Aanmelden met Google",
    setup582: "De eerste afbeelding is standaard de hoofdafbeelding. Sleep om aan te passen.",
    setup583: "Maximale uploadlimiet bereikt",
    setup584: "Log in met Telegram",
    setup585: "Logistiek bekijken",
    setup586: "Logistieke informatie",
    setup587: "Wijzig logistiek ordernummer",
    setup588: "Bind e-mail",
    setup589: "Verbind eerst je e-mail",
    setup590: "U kunt maximaal 2 specificatietypen invoeren!",
    setup591: "Algemene sjablonen",
    setup592: "Selecteer model",
    setup593: "Annuleren",
    setup594: "Toevoegen",
    setup595: "Selecteer de specificatiewaarde",
    setup596: "Niet herhaaldelijk toevoegen",
    setup597: "Algemene sjablonen succesvol ingesteld!",
    setup598: "SKU kan niet leeg zijn",
    setup599: "Prijs kan niet leeg zijn",
    setup600: "De hoeveelheid kan niet leeg zijn",
    setup601: "Kan niet dezelfde specificatiewaarde toevoegen!",
    setup602: "① Dubbelklik om te wijzigen",
    setup603: "Vul de specificatiegegevens in!",
    setup604: "Vul de productgegevens in, zowel in vereenvoudigd Chinees als in het Engels!",
    setup605: "Wijziging succesvol",
    setup606: "Specificatiewaarde succesvol toegevoegd!",
    setup607: "Instellen als gemeenschappelijk",
    setup608: "Vul minimaal één specificatiewaarde in!",
    setup609: "Voer vereenvoudigd Chinees in",
    setup610: "Voer Engels in",
    setup611: "Voer Spaans in",
    setup612: "Voer Portugees in",
    setup613: "Voer Nederlands in",
    setup614: "Voer Pools in",
    setup615: "Voer Duits in",
    setup616: "Voer Frans in",
    setup617: "Voer Italiaans in",
    setup618: "Automatische vertaling",
    setup619: "Vertaling",
    setup620: "Alle anderen",
    setup621: "VERZENDINFORMATIE",
    setup622: "Ons doel is om u de beste verzendopties te bieden, ongeacht waar u woont. We leveren elke dag aan honderden klanten over de hele wereld en we streven ernaar om u diensten van het hoogste niveau te bieden.",
    setup623: "A. Het tijdsbestek van de levering van een bestelling is verdeeld in twee delen:",
    setup624: "· Verwerkingstijd: 3-7 dagen",
    setup625: "· Verzendtijd: 14~30 dagen",
    setup626: "B. Verzendmethoden",
    setup627: "C. Verzendkosten",
    setup628: "Intellectuele eigendomsrechten",
    setup629: "Land/Zee Transport",
    setup630: "Wachten op ontvangst",
    setup631: "alliantie",
    setup632: "Deel uw affiliate code",
    setup633: "De vrienden die je hebt uitgenodigd, bevestigen dat ze je alliantiecode hebben ontvangen",
    setup634: "Ontvang uw affiliate commissie",
    setup635: "Kopieer deze URL en gebruik deze om gebruikers door te verwijzen naar de startpagina van uw affiliate-ID",
    setup636: "URL kopiëren",
    setup637: "Mijn Alliantie",
    setup638: "Opnemen",
    setup639: "Ophalen",
    setup640: "Veelgestelde vragen over eigen vermogen",
    setup641: "Wat is het affiliate programma?",
    setup642: "51Shopy is een project om te delen en geld te verdienen, geïnitieerd door alle gebruikers. Of u nu particulier of verkoper bent, sluit u aan bij een 51Shopy-promotor, nodig nieuwe gebruikers uit om zich te registreren op 51Shopy en succesvol te kopen. Zij/hij wordt uw exclusieve gebruiker en elk van zijn/haar internationale logistieke aankopen levert u geldkortingen op. Het kortingsbedrag kan oplopen tot een miljoen yuan, zonder maximum.",
    setup643: "Hoe wordt mijn bonus berekend?",
    setup644: "Zodra u lid wordt, krijgt u direct korting op uw account. Hoe meer internationale logistieke vrachtgebruikers u uitnodigt om zich te registreren, hoe meer bonussen u ontvangt en hoe hoger uw korting zal zijn. Wanneer de bonus een bepaald bedrag bereikt, kunt u een aanvraag indienen voor geldopname of het gebruiken om eventuele servicekosten van het 51Shopy-platform te dekken. Het kortingspercentage is",
    setup645: "Hoe promoot ik gratis?",
    setup646: "Kopieer je promotielink of promolink en stuur deze naar je vrienden door op Delen te klikken op de productpagina. Wanneer ze de pagina bezoeken en zich registreren, worden ze jouw unieke gebruiker.",
    setup647: 'Registratietijd',
    setup648: 'Transportkosten',
    setup649: 'Activeringsstatus',
    setup650: 'Bonusrecord',
    setup651: 'Toepassingstijd',
    setup652: 'Totale beloning',
    setup653: 'Gebruikers uitnodigen',
    setup654: 'Ga naar portemonnee',
    setup655: "Creditcard",
    setup656: "Nodig vrienden uit om van de commissie te genieten",
    setup657:"Gelieerd lid",
    setup658: "Inkooporder",
    setup659: "Het 51Shopy-agentplatform biedt u hulp bij het online en offline kopen van producten in China. Geef gewoon de productlink op en plaats de bestelling. Ons team biedt eersteklas service van begin tot eind.",
    setup660: "Verzenden naar magazijn",
    setup661:"Bij ons kunt u producten van verschillende verkopers kopen en deze laten verzenden naar het magazijn van 51Shopy in China",
    setup662: "Kwaliteitscontrole",
    setup663: "Zodra uw artikelen in het magazijn van 51Shopy aankomen, voeren we een grondige kwaliteitscontrole uit, waarbij we alles controleren, van defecten tot maat en kleur. U kunt erop vertrouwen dat 51Shopy een betrouwbare aftersales-servicegarantie biedt.",
    setup664:"Wereldwijde levering",
    setup665:"In het magazijn van 51Shopy kunt u uw producten vrij kiezen en combineren, en gebruikmaken van de betrouwbare logistieke service van 51Shopy om ze te verpakken en bij u thuis af te leveren.",
    setup666: "One-stop service, zorgeloos gedurende het hele proces",
    setup667:"Zodra de gebruikers die u uitnodigt zich registreren, ontvangen ze USD:",
    setup668: "Gratis verzending",
    setup669: "Exclusief verzendkosten",
    setup670: "Internationale verzending is niet inbegrepen",
    setup671:"Logistiek bedrijf",
    setup672: "Selecteer een logistiek bedrijf",
    setup673: "Laatste nummer van de afzender",
    setup674: "Laatste vier cijfers",
    setup675: "Consignornummer",
    setup676:"Voer in",
    setup677: "Wachten op opslag",
    setup678: "Zijn de internationale verzendkosten inbegrepen",
    setup679: "Ja",
    setup680: "Nee",
    setup681: "Klik op de knop 'Toevoegen aan startscherm'",
}
//荷兰